export type WithId<T> = T & { id: string };

/** How long a form's choices outlive the form, since the lists they come from rarely change. */
export const OPTION_LIST_CACHE_SECONDS = 600;

/**
 * Wrapper for RTK Query responses that use frontend entity types (which already include `id`).
 * Use this instead of `ApiResponseWithId` when the entity type is from a service's `types.ts`.
 */
export type EntityResponse<T> = {
  data: T;
};

type ApiResponse<T> = {
  data: T;
};

export type ApiResponseWithId<T> = {
  data: T extends (infer U)[] ? WithId<U>[] : WithId<T>;
};

export const attachId = <T>(
  response: ApiResponse<T>,
  fn: (entry: T) => string
): ApiResponseWithId<T> =>
  ({
    data: {
      ...response.data,
      id: fn(response.data),
    },
  }) as ApiResponseWithId<T>;

export const attachIds = <T>(
  response: ApiResponse<T[]>,
  fn: (entry: T) => string
): ApiResponseWithId<T[]> =>
  ({
    data: response.data.map(entry => ({
      ...entry,
      id: fn(entry),
    })),
  }) as ApiResponseWithId<T[]>;
